import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import CourierInfo from '@/model/modules/CourierInfo'

export default class CourierService extends BaseService {
  protected static baseUrl: string = '/courier'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<CourierInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<CourierInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/courier-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<CourierInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  // 2021-2-22 19:37:32，不再显示渠道列表，只显示平台列表了。
  // public static listScanformChannel(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<CourierInfo>> {
  //   example.page = pageNum
  //   example.size = pageSize
  //   return new Promise<BasePageableInfo<CourierInfo>>((resolve, reject) => {
  //     axios.get(this.baseUrl + '/courier-list-scanform-channel', {
  //       params: example
  //     }).then(resp => {
  //       const result: BasePageableInfo<CourierInfo> = new BasePageableInfo()
  //       result.count = resp.data.body.totalElements
  //       result.dataList = resp.data.body.content
  //       resolve(result)
  //     })
  //   })
  // }

  public static listWithUser(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<CourierInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<CourierInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/courier-list-by-user', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<CourierInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  public static saveGroupCourier(groupId: number, courierIdList: number[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios.post(this.baseUrl + '/save-group-courier', {
        groupId: groupId,
        courierId: courierIdList
      }).then(resp => {
        resolve()
      }).catch(e => {
        reject(e)
      })
    })
  }
}
